import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

import { useDispatch } from "react-redux";
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";

import { projectPriority } from "../lib/utils";
import BMXDatePicker from "../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";
import { entries } from "lodash";
import BMXAutocomplente from "../../../../../Components/Inputs/BMXAutocomplete/BMXAutocomplete";
import BMXUserView from "../../../../../Components/BMXUserView/BMXUserView";
const AddTaskStepOne = ({ workers, ...props }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [dictionaries, setDictionaries] = useState({});

  const { values, form } = props;

  const DICTIONARIES_TO_LOAD = [
    { name: "projectType", path: "/dictionary/projectProjectType/fieldName" },
  ];

  const fetchDictionary = async (dictionaryName, path) => {
    const response = await GlobalAuthFetch({ path });
    const entries = response?.payload?.data?.dictionaryEntries || [];

    setDictionaries((prev) => ({
      ...prev,
      [dictionaryName]: entries,
    }));
  };

  useEffect(() => {
    // LOADING DICTIONARIS
    const loadDictionaries = async () => {
      await Promise.all(
        DICTIONARIES_TO_LOAD.map((dict) =>
          fetchDictionary(dict.name, dict.path)
        )
      );
    };

    loadDictionaries();
  }, []);

  return (
    <div className="AddProjectStepOne" style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:crm.basicInformation")} />
      <Row>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:project.taskContent")}`}
            name="taskContent"
            data-cy="taskContent"
          />
        </Col>

        <Col xs={12}>
          <Field
            component={BMXTextField}
            multiline={true}
            maxRows={4}
            label={`${t("global:project.taskDescription")}`}
            name="taskDescription"
            data-cy="taskDescription"
          />
        </Col>

        <Col xs={{ span: 6 }}>
          <Field
            component={BMXAutocomplente}
            options={workers}
            data-cy="taskAssignee"
            currentValues={values}
            label={t("global:project.taskAssignee")}
            limitTags={1}
            multiple
            name="taskAssignee"
            renderOption={(props, option) => (
              <li key={option.uuid} {...props}>
                <BMXUserView color="primary" user={option}></BMXUserView>
              </li>
            )}
            getOptionLabel={(option) =>
              String(
                `${option.lastName} ${option.firstName} ${option.firstName} ${option.lastName}`
              )
            }
            renderTags={(values) => {
              return values.map((option, index) => (
                <BMXUserView
                  comma={values.length - 1 !== index}
                  key={option.uuid}
                  color="primary"
                  user={option}
                ></BMXUserView>
              ));
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={{ span: 4 }}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:project.taskStartDate")}*`}
            name="taskStartDate"
            data-cy="taskStartDate"
          />
        </Col>
        <Col xs={{ span: 4 }}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:project.taskEndDate")}*`}
            name="taskEndDate"
            data-cy="taskEndDate"
          />
        </Col>
        <Col xs={{ span: 4 }}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:project.taskDeadline")}*`}
            name="taskDeadline"
            data-cy="taskDeadline"
          />
        </Col>
      </Row>
    </div>
  );
};

export default AddTaskStepOne;
